import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { IoMdArrowBack } from "react-icons/io";
import { FiFileText, FiCheckCircle, FiShield, FiUser } from "react-icons/fi";

const Contract = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [formData, setFormData] = useState({
    itemTitle: location.state?.itemTitle || "",
    itemDescription: location.state?.itemDescription || "",
    price: location.state?.price || "",
    myName: "",
    otherPartyName: "",
    myEmail: "",
    otherPartyEmail: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (formData.price > 0) {
 // Navigate to the payment page and pass the complete form state
    navigate("/contract-payment", { state: formData });
    }
   
  };

  return (
    <div className="bg-gray-50 min-h-screen pb-12">
      {/* 🔝 Sticky Header matching your app design style */}
      <div className="sticky top-0 z-30 bg-white/80 backdrop-blur-md border-b px-4 py-4 flex items-center justify-between">
        <button
          onClick={() => navigate(-1)}
          className="p-2 hover:bg-gray-100 rounded-full transition text-gray-700 flex items-center gap-1"
        >
          <IoMdArrowBack size={24} />
          <span className="text-[10px] font-black uppercase tracking-widest">Back</span>
        </button>
        <h1 className="text-lg font-black text-gray-900 tracking-tight">Contract Agreement</h1>
        <button 
          onClick={() =>   navigate("/check-contract")}
          className="bg-orange-600 hover:bg-orange-700 text-white text-[10px] font-black uppercase tracking-widest px-4 py-2.5 rounded-xl transition shadow-md shadow-orange-100"
        >
          Check Contracts
        </button>
      </div>

      <div className="max-w-xl mx-auto px-6 pt-8">
        
        {/* 🛡️ Info Banner */}
        <div className="bg-teal-900 rounded-[2.5rem] p-6 mb-8 text-white shadow-xl shadow-teal-100 overflow-hidden relative">
          <div className="absolute right-[-10%] top-[-20%] w-32 h-32 bg-white/10 rounded-full blur-3xl"></div>
          <div className="relative z-10">
            <div className="flex items-center gap-3 mb-4">
               <div className="p-2 bg-teal-800 rounded-xl"><FiShield className="text-teal-100" /></div>
               <h2 className="text-sm font-black uppercase tracking-widest">OurASAP Fast Contract</h2>
            </div>
            <div className="space-y-3">
              {[
                "Simple marketplace protection for quick buyers & sellers",
                "Instant binding terms for fast transactions",
                "Automated digital copies sent to both emails"
              ].map((text, i) => (
                <div key={i} className="flex items-center gap-3 text-xs font-bold text-teal-50">
                  <FiCheckCircle className="text-teal-400 shrink-0" /> {text}
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* 📝 Contract Form */}
        <form onSubmit={handleSubmit} className="space-y-6">
          <div className="bg-white p-8 rounded-[2.5rem] shadow-xl shadow-gray-200/50 border border-gray-100 space-y-6">
            <h3 className="text-xl font-black text-gray-900 flex items-center gap-2">
              <FiFileText className="text-orange-600" /> Deal Terms
            </h3>

            {/* Item Title */}
            <div className="space-y-2">
              <label className="text-[10px] font-black text-gray-400 uppercase tracking-widest ml-2">Item / Service Name *</label>
              <input 
                type="text" 
                name="itemTitle" 
                required
                value={formData.itemTitle}
                onChange={handleChange}
                placeholder="e.g., iPhone 14 Pro / Cleaning Service" 
                className="w-full bg-gray-50 border-2 border-gray-100 focus:border-orange-500 focus:bg-white rounded-2xl py-4 px-5 font-bold text-gray-900 transition-all outline-none"
              />
            </div>

            {/* Description */}
            <div className="space-y-2">
              <label className="text-[10px] font-black text-gray-400 uppercase tracking-widest ml-2">Agreement Conditions / Description *</label>
              <textarea 
                name="itemDescription" 
                required
                rows="3"
                value={formData.itemDescription}
                onChange={handleChange}
                placeholder="State exact deliverables, conditions, or guarantees..." 
                className="w-full bg-gray-50 border-2 border-gray-100 focus:border-orange-500 focus:bg-white rounded-2xl py-4 px-5 font-bold text-gray-900 transition-all outline-none resize-none"
              />
            </div>

            {/* Price */}
            <div className="space-y-2">
              <label className="text-[10px] font-black text-gray-400 uppercase tracking-widest ml-2">Agreed Amount (₦) *</label>
              <input 
                type="number" 
                name="price" 
                required
                value={formData.price}
                onChange={handleChange}
                placeholder="0.00" 
                className="w-full bg-gray-50 border-2 border-gray-100 focus:border-orange-500 focus:bg-white rounded-2xl py-4 px-5 font-bold text-gray-900 transition-all outline-none"
              />
            </div>
          </div>

          {/* Parties Details Card */}
          <div className="bg-white p-8 rounded-[2.5rem] shadow-xl shadow-gray-200/50 border border-gray-100 space-y-6">
            <h3 className="text-xl font-black text-gray-900 flex items-center gap-2">
              <FiUser className="text-orange-600" /> Parties Involved
            </h3>

            <div className="space-y-4">
              {/* My Name */}
              <div className="space-y-2">
                <label className="text-[10px] font-black text-gray-400 uppercase tracking-widest ml-2">My Name *</label>
                <input 
                  type="text" 
                  name="myName" 
                  required
                  value={formData.myName}
                  onChange={handleChange}
                  placeholder="Your Name" 
                  className="w-full bg-gray-50 border-2 border-gray-100 focus:border-orange-500 focus:bg-white rounded-2xl py-4 px-5 font-bold text-gray-900 transition-all outline-none"
                />
              </div>

              {/* Other Party Name */}
              <div className="space-y-2">
                <label className="text-[10px] font-black text-gray-400 uppercase tracking-widest ml-2">Other Party Name *</label>
                <input 
                  type="text" 
                  name="otherPartyName" 
                  required
                  value={formData.otherPartyName}
                  onChange={handleChange}
                  placeholder="Other Party Name" 
                  className="w-full bg-gray-50 border-2 border-gray-100 focus:border-orange-500 focus:bg-white rounded-2xl py-4 px-5 font-bold text-gray-900 transition-all outline-none"
                />
              </div>

              {/* My Email */}
              <div className="space-y-2">
                <label className="text-[10px] font-black text-gray-400 uppercase tracking-widest ml-2">My Email *</label>
                <input 
                  type="email" 
                  name="myEmail" 
                  required
                  value={formData.myEmail}
                  onChange={handleChange}
                  placeholder="name@example.com" 
                  className="w-full bg-gray-50 border-2 border-gray-100 focus:border-orange-500 focus:bg-white rounded-2xl py-4 px-5 font-bold text-gray-900 transition-all outline-none"
                />
              </div>

              {/* Other Party Email */}
              <div className="space-y-2">
                <label className="text-[10px] font-black text-gray-400 uppercase tracking-widest ml-2">Other Party Email *</label>
                <input 
                  type="email" 
                  name="otherPartyEmail" 
                  required
                  value={formData.otherPartyEmail}
                  onChange={handleChange}
                  placeholder="name@example.com" 
                  className="w-full bg-gray-50 border-2 border-gray-100 focus:border-orange-500 focus:bg-white rounded-2xl py-4 px-5 font-bold text-gray-900 transition-all outline-none"
                />
              </div>
            </div>
          </div>

          {/* Submit Button */}
          <button
            type="submit"
            className="w-full py-5 bg-gray-900 hover:bg-black text-white rounded-[1.5rem] font-black uppercase tracking-[0.2em] text-sm transition-all shadow-xl shadow-gray-300 active:scale-95 flex items-center justify-center gap-3"
          >
            <FiCheckCircle size={18} />
            Proceed to Payment
          </button>
        </form>

        <p className="text-center mt-10 text-[10px] font-black text-gray-300 uppercase tracking-widest">
          Secure Contracts • Instant Enforcement • OurASAP
        </p>
      </div>
    </div>
  );
};

export default Contract;